import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesOverviewPage } from './pages/ServicesOverviewPage';
import { ICAMPage } from './pages/ICAMPage';
import { ICAMCapabilitiesPage } from './pages/ICAMCapabilitiesPage';
import { ICAMResourcesPage } from './pages/ICAMResourcesPage';
import { ProgramManagementPage } from './pages/ProgramManagementPage';
import { PMAgilePage } from './pages/PMAgilePage';
import { PMPMOPage } from './pages/PMPMOPage';
import { AboutPage } from './pages/AboutPage';
import { LeadershipPage } from './pages/LeadershipPage';
import { CareersPage } from './pages/CareersPage';
import { PartnersPage } from './pages/PartnersPage';
import { CertificationsPage } from './pages/CertificationsPage';
import { ContractVehiclesPage } from './pages/ContractVehiclesPage';
import { NasaSewpPage } from './pages/NasaSewpPage';
import { CommunityPage } from './pages/CommunityPage';
import { ContactPage } from './pages/ContactPage';
// Existing ServiceNow Pages
import { ServiceNowHomePage } from './pages/ServiceNowHomePage';
import { ServicesPage as ServiceNowServicesPage } from './pages/ServicesPage';
import { SecureOnPremisePage } from './pages/SecureOnPremisePage';
import { ThoughtLeadershipPage } from './pages/ThoughtLeadershipPage';
import { CalculatorPage } from './pages/CalculatorPage';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { AIServicesPage } from './pages/AIServicesPage';
import { ArticlePage } from './pages/ArticlePage';
import { CrossInstanceSyncChecklistPage } from './pages/CrossInstanceSyncChecklistPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppLayout() {
  return <div className="min-h-screen flex flex-col font-body" data-id="element-0" data-mp="swgm3tmn7arr">
      <Navigation data-id="element-1" data-mp="356wji4cy4fe" />
      <main className="flex-1" data-id="element-2" data-mp="34ndtz6vvc0b">
        <Routes data-id="element-3" data-mp="3ud1g7bihxsbo">
          <Route path="/" element={<HomePage data-id="element-5" data-mp="3ubztg9s4bhe4" />} data-id="element-4" data-mp="3udkos1m9b4d1" />

          {/* Services Routes */}
          <Route path="/services" element={<ServicesOverviewPage data-id="element-7" data-mp="d3cuxpqygsfi" />} data-id="element-6" data-mp="d4e9i476jx1z" />
          <Route path="/services/ai" element={<AIServicesPage data-id="element-9" data-mp="851n1kk80rzx" />} data-id="element-8" data-mp="d2biphy7dzw7" />

          {/* Identity & Access Management Sub-site */}
          <Route path="/services/identity-access-management" element={<ICAMPage data-id="element-11" data-mp="3glnz048296jt" />} data-id="element-10" data-mp="3gl4qtf87pwiz" />
          <Route path="/services/identity-access-management/capabilities" element={<ICAMCapabilitiesPage data-id="element-13" data-mp="3bo4l55f9yvse" />} data-id="element-12" data-mp="3bmbf9schkflg" />
          <Route path="/services/identity-access-management/resources" element={<ICAMResourcesPage data-id="element-15" data-mp="3qdajysa7ajzr" />} data-id="element-14" data-mp="3qaxttruah3bm" />

          {/* Program & Project Management Sub-site */}
          <Route path="/services/program-and-project-management" element={<ProgramManagementPage data-id="element-17" data-mp="2xtv6eawwlncm" />} data-id="element-16" data-mp="3lj67jti61jra" />
          <Route path="/services/program-and-project-management/agile" element={<PMAgilePage data-id="element-19" data-mp="2sv0odb6rg2tk" />} data-id="element-18" data-mp="2xssgo6bbhqya" />
          <Route path="/services/program-and-project-management/pmo" element={<PMPMOPage data-id="element-21" data-mp="18czlufkf77kw" />} data-id="element-20" data-mp="2stpnbj4p9965" />

          {/* ServiceNow Sub-site Routes */}
          <Route path="/services/servicenow" element={<ServiceNowHomePage data-id="element-23" data-mp="1d62l94bvpb90" />} data-id="element-22" data-mp="1d4ztyvan96sk" />
          <Route path="/services/servicenow/services" element={<ServiceNowServicesPage data-id="element-25" data-mp="ygwodn0ijx4a" />} data-id="element-24" data-mp="yflkln72ipd6" />
          <Route path="/services/servicenow/secure-on-premise" element={<SecureOnPremisePage data-id="element-27" data-mp="13f7upnrlnphr" />} data-id="element-26" data-mp="13eoce5y1ez37" />
          <Route path="/services/servicenow/thought-leadership" element={<ThoughtLeadershipPage data-id="element-29" data-mp="1r4sgsfj1v2v9" />} data-id="element-28" data-mp="1r498zrn45uuy" />
          <Route path="/services/servicenow/thought-leadership/:slug" element={<ArticlePage data-id="element-31" data-mp="1w2ki205l41c4" />} data-id="element-30" data-mp="1w3c1ydptkamk" />
          <Route path="/services/servicenow/calculator" element={<CalculatorPage data-id="element-33" data-mp="1i2sxthoh5opo" />} data-id="element-32" data-mp="1i3kuywxpzui2" />
          <Route path="/services/servicenow/case-studies" element={<CaseStudiesPage data-id="element-35" data-mp="1m44si1m7h04q" />} data-id="element-34" data-mp="1i5x9f049rmqd" />

          {/* Resources */}
          <Route path="/resources/cross-instance-sync-checklist" element={<CrossInstanceSyncChecklistPage data-id="element-37" data-mp="6n4bmsj1otpx" />} data-id="element-36" data-mp="6onr4gwvn0qn" />

          {/* About Us Routes */}
          <Route path="/about-us" element={<AboutPage data-id="element-39" data-mp="ano6tqk25n9f" />} data-id="element-38" data-mp="aqsljhv5g1ec" />
          <Route path="/about-us/our-team" element={<LeadershipPage data-id="element-41" data-mp="qyqavo0wi78c" />} data-id="element-40" data-mp="qwvsagd3qr7f" />
          <Route path="/about-us/partners" element={<PartnersPage data-id="element-43" data-mp="m65huoptjy5v" />} data-id="element-42" data-mp="qyyqhnoerqn8" />
          <Route path="/about-us/certifications" element={<CertificationsPage data-id="element-45" data-mp="h72ow2n45ie9" />} data-id="element-44" data-mp="m4ujj4f57im5" />
          <Route path="/about-us/community" element={<CommunityPage data-id="element-47" data-mp="h4zoqps8y8vt" />} data-id="element-46" data-mp="h8414afv8axk" />
          <Route path="/about-us/contract-vehicles" element={<ContractVehiclesPage data-id="element-49" data-mp="ca2ghl2sk3jz" />} data-id="element-48" data-mp="c8re9pozv3uz" />
          <Route path="/about-us/contract-vehicles/nasa-sewp-vi" element={<NasaSewpPage data-id="element-51" data-mp="19tx7sv4a89pm" />} data-id="element-50" data-mp="19vrhtee0mhex" />

          {/* Other Routes */}
          <Route path="/careers" element={<CareersPage data-id="element-53" data-mp="14xpxkq4usc1v" />} data-id="element-52" data-mp="14xyf4vbx85je" />
          <Route path="/contact-us" element={<ContactPage data-id="element-55" data-mp="zwsiwnj1y054" />} data-id="element-54" data-mp="zxtuct3zcond" />
        </Routes>
      </main>
      <Footer data-id="element-56" data-mp="zzoew6bcaeqx" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-57" data-mp="vvgqka8sn0t8">
      <ScrollToTop data-id="element-58" data-mp="vvyrvlabc580" />
      <AppLayout data-id="element-59" data-mp="3ko2riny8x0um" />
    </BrowserRouter>;
}